// Tier 4 (ALGO TRADING — MT5 & Expert Advisors) — 25 lessons across modules 4.1–4.5.
// Static imports so the PWA bundles lesson data at build time (zero network calls, works offline).
import lessonsT4_1to2 from "./axel-lessons-4.1.1-to-4.2.5.json";
import lessonsT4_3to4 from "./axel-lessons-4.3.1-to-4.4.5.json";
import lessonsT4_5 from "./axel-lessons-4.5.1-to-4.5.5.json";
import { normalizeLesson } from "./normalizeQuiz";

const unwrap = (src) => (Array.isArray(src) ? src : src?.lessons || []);

export const TIER4_LESSONS = [
  ...unwrap(lessonsT4_1to2),
  ...unwrap(lessonsT4_3to4),
  ...unwrap(lessonsT4_5),
]
  .map(normalizeLesson)
  .sort((a, b) => (a.id || "").localeCompare(b.id || "", undefined, { numeric: true }));
